import { render, staticRenderFns } from "./SearchItem.vue?vue&type=template&id=7d37d576&scoped=true&"
import script from "./SearchItem.vue?vue&type=script&lang=js&"
export * from "./SearchItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchItem.vue?vue&type=style&index=0&id=7d37d576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d37d576",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d37d576')) {
      api.createRecord('7d37d576', component.options)
    } else {
      api.reload('7d37d576', component.options)
    }
    module.hot.accept("./SearchItem.vue?vue&type=template&id=7d37d576&scoped=true&", function () {
      api.rerender('7d37d576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/a-kit/SearchItem.vue"
export default component.exports